import { useTranslations } from "next-intl";

import { FormButton } from "@/components/form/FormButton";
import { Icon } from "@/components/icons/Icon";
import { trackEvent } from "@/utils/trackEvent";
import { twMerge } from "@/utils/twMerge";

import { CopyPublicLink } from "./CopyPublicLink";

import type { DocumentModel } from "@/models/DocumentModel";

export const CopyLinkButtons = ({
  doc,
  onQRCodeClick,
  disabled,
}: {
  doc: DocumentModel;
  onQRCodeClick: () => void;
  disabled?: boolean;
}) => {
  const t = useTranslations();

  const handleQRCodeClick = () => {
    if (doc.id) {
      trackEvent("share_qr_code_clicked", { doc_id: doc.id });
    }
    onQRCodeClick();
  };

  return (
    <div className={twMerge("flex flex-row mt-2", "sm:flex-col")}>
      <CopyPublicLink
        doc={doc}
        className={twMerge("flex-1 max-w-[260px] mr-2.5", "sm:max-w-full sm:mb-2.5 sm:mr-0")}
        disabled={disabled}
      />
      <FormButton
        className="flex rounded-6 h-9 text-[15px]"
        variant="solid"
        onClick={handleQRCodeClick}
        disabled={disabled}
      >
        <Icon name="QRCode" className="-ml-1 mr-1.5" />
        {t("share.publicQRCode")}
      </FormButton>
    </div>
  );
};
